import {fetchApi, fetchFile, fetchWithToken} from './Fetch'

export function profile(onSuccess, onFailure) {
    fetchWithToken(`/account/profile`, 'GET', {}, onSuccess, onFailure, false)
}

export function refreshToken(onSuccess, onFailure) {
    fetchWithToken(`/account/refresh-token`, 'POST', {}, onSuccess, onFailure, false)
}

export function login(usernameEmail, password, onSuccess, onFailure) {
    fetchApi(`/account/login`, 'post', {
        usernameEmail: usernameEmail,
        password: password
    }, onSuccess, onFailure)
}

export function forgotPassword(usernameEmail, onSuccess, onFailure) {
    fetchApi(`/account/forgot-password/request`, 'post', {
        usernameEmail: usernameEmail,
    }, onSuccess, onFailure)
}

export function forgotPasswordSubmit(usernameEmail, code, password, onSuccess, onFailure) {
    fetchApi(`/account/forgot-password/submit`, 'post', {
        usernameEmail: usernameEmail,
        code: code,
        password: password,
    }, onSuccess, onFailure)
}

export function uploadProfilePhoto(image, onSuccess, onFailure) {
    fetchFile(`/file/upload`, {
        file: image,
        profile: true,
    }, onSuccess, onFailure)
}

export function registerAccount(param, onSuccess, onFailure) {
    fetchApi(`/account/register`, 'post', param, onSuccess, onFailure)
}

export function sendCodeAgain(username, onSuccess, onFailure) {
    fetchApi(`/account/send-code`, 'post', {usernameEmail: username}, onSuccess, onFailure)
}

export function editAccount(param, onSuccess, onFailure) {
    fetchWithToken(`/account/edit`, 'post', param, onSuccess, onFailure)
}

export function countryList(onSuccess, onFailure) {
    fetchApi(`/static/country`, 'GET', {}, onSuccess, onFailure)
}

export function activate(email, code, onSuccess, onFailure) {
    fetchApi(`/account/activate`, 'post', {
        usernameEmail: email,
        code: code,
    }, onSuccess, onFailure)
}

export function changeStatus(online, onSuccess, onFailure) {
    fetchWithToken(`/tutor/status`, 'post', {
        online: online,
    }, onSuccess, onFailure)
}

export function getFields(onSuccess, onFailure) {
    fetchApi(`/static/field`, 'GET', {}, onSuccess, onFailure)
}

export function getCategories(fieldHashId, onSuccess, onFailure) {
    fetchApi(`/static/category`, 'GET', {fieldHashId: fieldHashId}, onSuccess, onFailure)
}

export function taskPrice(categoryHashId, deadline, onSuccess, onFailure) {
    fetchWithToken(`/task/student/price`, 'POST', {
        categoryHashId: categoryHashId,
        deadline: deadline,
    }, onSuccess, onFailure)
}

export function taskCreate(title, description, categoryHashId, deadline, tutorHashId, onSuccess, onFailure) {
    let param = {
        title: title,
        description: description,
        categoryHashId: categoryHashId,
        deadline: deadline,
    }
    if (tutorHashId)
        param = {
            ...param,
            tutorHashId: tutorHashId
        }
    fetchWithToken(`/task/student/create`, 'POST', param, onSuccess, onFailure)
}

export function uploadFilePrivate(taskHashId, file, onSuccess, onFailure) {
    fetchFile(`/file/upload`, {
        taskHashId: taskHashId,
        profile: false,
        file: file,
    }, onSuccess, onFailure)
}

export function uploadFilePrivateAnswer(taskHashId, file, onSuccess, onFailure) {
    fetchFile(`/file/upload`, {
        taskHashId: taskHashId,
        profile: false,
        file: file,
        answer: true,
    }, onSuccess, onFailure)
}

export function getCurrentTaskStudent(onSuccess, onFailure) {
    fetchWithToken(`/task/student/current`, 'GET', {}, onSuccess, onFailure)
}

export function getCurrentTaskTutor(onSuccess, onFailure) {
    fetchWithToken(`/task/tutor/current`, 'GET', {}, onSuccess, onFailure)
}

export function getCurrentTaskNeedScore(onSuccess, onFailure) {
    fetchWithToken(`/task/student/need-score`, 'GET', {}, onSuccess, onFailure)
}

export function cancelSearch(taskHashId, onSuccess, onFailure) {
    fetchWithToken(`/task/student/cancel-search`, 'POST', {taskHashId: taskHashId}, onSuccess, onFailure)
}

export function cancelTaskByTutor(taskHashId, onSuccess, onFailure) {
    fetchWithToken(`/task/tutor/cancel`, 'POST', {taskHashId: taskHashId}, onSuccess, onFailure)
}

export function trySearch(taskHashId, onSuccess, onFailure) {
    fetchWithToken(`/task/student/try-search`, 'POST', {taskHashId: taskHashId}, onSuccess, onFailure)
}

export function sendFeedback(taskHashId, score, feedback, onSuccess, onFailure) {
    fetchWithToken(`/task/student/feedback`, 'POST', {
        taskHashId: taskHashId,
        score: score,
        feedback: feedback,
    }, onSuccess, onFailure)
}

export function tryPay(taskHashId, onSuccess, onFailure) {
    fetchWithToken(`/task/student/try-pay`, 'POST', {taskHashId: taskHashId}, onSuccess, onFailure)
}

export function confirmTaskByStudent(taskHashId, onSuccess, onFailure) {
    fetchWithToken(`/task/student/done`, 'POST', {taskHashId: taskHashId}, onSuccess, onFailure)
}

export function rejectAnswerTaskByStudent(taskHashId, onSuccess, onFailure) {
    fetchWithToken(`/task/student/reject-answer`, 'POST', {taskHashId: taskHashId}, onSuccess, onFailure)
}

export function getCategoryList(onSuccess, onFailure) {
    fetchWithToken(`/tutor/category/list`, 'GET', {}, onSuccess, onFailure)
}

export function addCategory(categoryHashId, onSuccess, onFailure) {
    fetchWithToken(`/tutor/category/add`, 'POST', {categoryHashId: categoryHashId}, onSuccess, onFailure)
}

export function removeCategory(categoryHashId, onSuccess, onFailure) {
    fetchWithToken(`/tutor/category/remove`, 'POST', {categoryHashId: categoryHashId}, onSuccess, onFailure)
}

export function acceptTask(taskTutorHashId, onSuccess, onFailure) {
    fetchWithToken(`/task/tutor/accept`, 'POST', {taskTutorHashId: taskTutorHashId}, onSuccess, onFailure)
}

export function rejectTask(taskTutorHashId, onSuccess, onFailure) {
    fetchWithToken(`/task/tutor/reject`, 'POST', {taskTutorHashId: taskTutorHashId}, onSuccess, onFailure)
}

export function removeCard(onSuccess, onFailure) {
    fetchWithToken(`/account/remove-card`, 'POST', {}, onSuccess, onFailure)
}

export function checkChat(me, other, onSuccess, onFailure) {
    fetchWithToken(`/account/check-chat`, 'POST', {me: me, other: other}, onSuccess, onFailure)
}

export function taskDoneByTutor(taskHashId, files, onSuccess, onFailure) {
    fetchWithToken(`/task/tutor/done`, 'POST', {taskHashId: taskHashId, files: files}, onSuccess, onFailure)
}

export function addToMyFavorite(tutorHashId, onSuccess, onFailure) {
    fetchWithToken(`/favorite/add`, 'POST', {tutorHashId: tutorHashId}, onSuccess, onFailure)
}

export function removeMyFavorite(tutorHashId, onSuccess, onFailure) {
    fetchWithToken(`/favorite/remove`, 'POST', {tutorHashId: tutorHashId}, onSuccess, onFailure)
}

export function listMyFavorite(onSuccess, onFailure) {
    fetchWithToken(`/favorite/list`, 'GET', {}, onSuccess, onFailure)
}

export function getCredit(onSuccess, onFailure) {
    fetchWithToken(`/account/credit`, 'GET', {}, onSuccess, onFailure)
}

export function getListTaskStudent(onSuccess, onFailure) {
    fetchWithToken(`/task/student/list`, 'GET', {}, onSuccess, onFailure)
}

export function getListTaskTutor(onSuccess, onFailure) {
    fetchWithToken(`/task/tutor/list`, 'GET', {}, onSuccess, onFailure)
}

export function appVersion(onSuccess, onFailure) {
    fetchApi(`/static/app-version`, 'GET', {}, onSuccess, onFailure);
}

export function deleteAccount(onSuccess, onFailure) {
    fetchWithToken(`/account/delete`, 'POST', {}, onSuccess, onFailure);
}

export function payForBangladesh(taskHashId, onSuccess, onFailure) {
    fetchWithToken(`/task/student/pay-bangladesh`, 'POST', {taskHashId: taskHashId, inApp: false}, onSuccess, onFailure);
}
